import { combineLatest, Subject } from 'rxjs';
import { filter, map, take, takeUntil } from 'rxjs/operators';
import { Component, Input, OnInit, OnDestroy } from '@angular/core';

import { PaymentService } from '@core/services/payment/payment.service';
import { PaymentStoreDispatcher } from '@common/dispatchers/payment.dispatcher';
import { DoodOrderModel } from '@store/order/order.model';
import { AnalyticsService } from '@core/services/app/analytics.service';

@Component({
  selector: 'app-pat-payment-panel-yavin',
  template: ` @if (isUnique) {
    <div class="absolute inset-0 z-100 flex h-screen items-center justify-center bg-white">
      <div class="flex flex-col items-center justify-center gap-8 p-12">
        <i class="icon icon-privacy animate-pulse text-4xl"></i>
        <h1 class="text-center text-xl font-bold">
          {{ 'pat.redirect-to-payment-page' | translate }}
        </h1>
      </div>
    </div>
  }`,
  standalone: false,
})
export class PatPaymentPanelYavinComponent implements OnInit, OnDestroy {
  @Input() isUnique = false;
  protected readonly unsubscribe$ = new Subject<boolean>();
  order: DoodOrderModel | null = null;

  constructor(
    private readonly paymentService: PaymentService,
    private paymentDispatcher: PaymentStoreDispatcher,
    private readonly analyticsService: AnalyticsService,
  ) {}

  ngOnInit(): void {
    this.paymentService.pay$.next(false);

    this.paymentDispatcher.updateUI({
      button: {
        text: 'yavin.pay-button',
        isEnabled: false,
      },
      status: {
        isLoading: true,
      },
    });

    if (this.isUnique) {
      this.paymentDispatcher.updateButton({
        text: 'pat.redirect-to-payment-page',
      });
      setTimeout(() => {
        this.paymentService.pay$.next(true);
      }, 0);
    }

    combineLatest([this.paymentService.pay$, this.paymentService.paymentYavinIntent$])
      .pipe(
        takeUntil(this.unsubscribe$),
        filter(([pay, paymentIntent]) => pay === true && !!paymentIntent?.payment_page_url),
        take(1),
        map(([_, paymentIntent]) => {
          const url = paymentIntent!.payment_page_url;
          window.location.href = url;
        }),
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.paymentDispatcher.resetUI();
    this.unsubscribe$.next(true);
    this.unsubscribe$.complete();
  }
}
